document.addEventListener('alpine:init', () => {

    Alpine.data('test', () => ({
        testtext: 'Lorem ipsum dolor sit amet.'
    }));

});
